import { useTrackActions } from '../../hooks/bi/useTrackActions';
import { createHOCWithHookInside } from '../createHOCWithHookInside';

/**
 * @deprecated use "useTrackActions"
 */
export const withTrackActions = createHOCWithHookInside('WithTrackActions', useTrackActions);
